export const ROUTES = {
    INDEX: "/",
    SIGNUP: "/signup",
    DASHBOARD:"/dashboard",
    MEETING:"/meeting",
    MEETING_LINK:"/meeting/link",
    USER_LIST:"/user-list"
   
  };